/**
 * Static data for the /curtains-dubai page.
 *
 * Extracted from `src/pages/CurtainsDubai.jsx` so the page component stays
 * focused on layout + form logic. Edit copy/imagery here without touching
 * the page itself.
 */

export const PRICING_TIERS = [
  {
    name: "Essential Collection",
    tag: "Essentials",
    blurb: "Clean, dependable, value-driven.",
    points: ["Simple fabrics", "Manual curtains", "Ideal for rental units"],
  },
  {
    name: "Signature Collection",
    tag: "Signature",
    featured: true,
    blurb: "The balanced choice for most homes.",
    points: ["Premium fabrics", "Custom stitching", "Modern curtain styles"],
  },
  {
    name: "Premium Collection",
    tag: "Designer",
    blurb: "Designer fabrics + smart automation.",
    points: [
      "Designer fabrics",
      "Motorized systems",
      "Full home automation integration",
    ],
  },
];

export const CURTAIN_TYPES = [
  {
    name: "Ripple Fold Curtains",
    img: "/services/Ripplefold-curtains-timefurniture.webp",
    alt: "Ripple fold curtains in a luxury Dubai living room by Time Furniture",
  },
  {
    name: "M-Track Curtains",
    img: "/services/M-Track-curtains-timefurniture.webp",
    alt: "M-track curtains in a modern Dubai apartment by Time Furniture",
  },
  {
    name: "Pinch Pleat Curtains",
    img: "/services/pinch-pleat-curtains-timefurniture.webp",
    alt: "Pinch pleat curtains in a Dubai villa by Time Furniture",
  },
  {
    name: "Blackout Curtains",
    img: "/services/blackout-curtains-timefurniture.webp",
    alt: "Blackout curtains in a Dubai bedroom by Time Furniture",
  },
  {
    name: "Sheer Curtains",
    img: "/services/sheer-curtains-timefurniture.webp",
    alt: "Sheer curtains in a luxury Dubai living room by Time Furniture",
  },
  {
    name: "Double Layer Curtains",
    img: "/services/Double Layer Curtains_timefurniture.JPG",
    alt: "Double layer curtains installation in Dubai by Time Furniture",
  },
];

export const BLINDS = [
  {
    name: "Roller Blinds",
    img: "/services/rollerBlinds-timefurniture.webp",
    alt: "Roller blinds for Dubai apartments by Time Furniture",
  },
  {
    name: "Zebra Blinds",
    img: "/services/Zebra-Blinds-timefurniture.webp",
    alt: "Zebra blinds installation in Dubai by Time Furniture",
  },
  {
    name: "Roman Blinds",
    img: "/services/roman-Blinds-timefurniture.webp",
    alt: "Roman blinds custom made in UAE by Time Furniture",
  },
  {
    name: "Vertical Blinds",
    img: "/services/Vertical-Blinds-timefurniture.webp",
    alt: "Vertical blinds for office interiors in UAE",
  },
];

export const WHY_CHOOSE = [
  "400+ fabric catalogues",
  "In-house stitching team",
  "Craftsmanship since 1993 — over 30 years of expertise",
  "Custom measurement and fitting",
  "Manual and motorized options",
  "Serving Dubai & Sharjah since 1993",
];

export const FAQS = [
  {
    q: "What decides my curtain quotation?",
    a: "Your quotation is shaped by the fabric you choose, the lining (sheer, dimout or blackout), the stitching style, track or rod hardware, motorisation, window size and installation complexity. We confirm everything with an on-site measurement before quoting, so there are no surprises.",
  },
  {
    q: "Do you take single-room or single-window orders?",
    a: "Yes. Individual rooms and single windows are as welcome as full villas, offices and holiday-home projects — the same measurement, stitching and installation team handles every order.",
  },
  {
    q: "What brands do you use for automation?",
    a: "We fit Somfy and Silent Gliss motor systems — both chosen for reliability and silent operation. Lutron scene integration is possible with compatible shades via the appropriate interface (e.g. Lutron dry-contact modules), and KNX/BMS integration is available on request. The exact motor and control pairing is confirmed during specification.",
  },
  {
    q: "Do you provide installation?",
    a: "Every project includes precise on-site measurement, in-house stitching at our Sharjah atelier, and installation by our own team — no third-party subcontractors.",
  },
  {
    q: "How long does curtain installation take?",
    a: "Standard curtain installations are typically completed within a few days after measurement and fabrication — actual timing depends on fabric availability and specifications.",
  },
  {
    q: "Do you provide motorized curtains?",
    a: "Yes. We supply and install motorized curtains and blinds on Somfy and Silent Gliss motor platforms, with remote, wall-switch, app and schedule control. Smart-home and Lutron scene integration is available where the selected motor and control system are compatible — we confirm the correct interface during specification rather than assuming universal compatibility.",
  },
  {
    q: "What is the best curtain style for apartments in Dubai?",
    a: "Ripple fold and sheer curtains are popular for modern apartments, while blackout or double-layer (sheer + blackout) setups are ideal for bedrooms.",
  },
];

export const INITIAL_FORM = {
  name: "",
  phone: "",
  location: "",
  type: "Curtains",
  curtainStyle: "Not sure",
  propertyType: "Residential",
  numWindows: "",
  knowsSize: "Need help with measurement (free site visit)",
  height: "",
  width: "",
  automation: "No",
  message: "",
};
